module.exports = __webpack_public_path__ + "static/media/Spinner.793f863c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/RequestTable/Spinner.svg
// module id = 310
// module chunks = 0